module.exports = __webpack_public_path__ + "static/img/hyper-tube-wall-hole_256.aa99589.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-wall-hole_256.png
// module id = OViV
// module chunks = 0